import {Injectable} from '@angular/core';
import {ConfigAPIService} from '@app/services/api/config-api.service';
import {ModulePackagesService} from '@app/services/api/module-packages.service';
import {VirtualSalonEntitlementRefreshService} from '@app/modules/virtual-salon/virtual-salon-entitlement-refresh.service';

/**
 * Single place every module-package activation/deactivation success path
 * must call. Before this existed, five call sites each hand-rolled their
 * own subset of cache invalidation, and none of them notified
 * VirtualSalonEntitlementRefreshService — which is why the Virtual Salon
 * shell's nav badge could stay stale after a tier switch even though the
 * account config cache itself was correctly reset elsewhere.
 */
@Injectable({providedIn: 'root'})
export class ModulePackageActivationSyncService {
  constructor(
    private configApi: ConfigAPIService,
    private modulePackagesService: ModulePackagesService,
    private entitlementRefresh: VirtualSalonEntitlementRefreshService
  ) {
  }

  syncAfterChange(): void {
    this.configApi.resetConfigCaches();
    this.modulePackagesService.clearCache();
    this.entitlementRefresh.notifyChanged();
  }
}
